export const missingWidth =
  'Image resize height was given without a resize width.' +
  ' Both height and width are required.'

export const missingHeight =
  'Image resize width was given without a resize height.' +
  ' Both height and width are required.'

export const invalidWidth =
  'Image resize width must be greater than zero, or null.'

export const invalidHeight =
  'Image resize height must be greater than zero, or null.'
